import type { CalendarioGoogle, ConexionGoogle } from '../types'

const CALENDARIOS_BASE: CalendarioGoogle[] = [
  { id: 'primary', nombre: 'Principal' },
  { id: 'litigio', nombre: 'Litigio y audiencias' },
  { id: 'terminos', nombre: 'Términos y plazos' },
]

function haceHoras(horas: number): string {
  return new Date(Date.now() - horas * 3600 * 1000).toISOString()
}

export function conexionVacia(abogadoId: string): ConexionGoogle {
  return {
    abogadoId,
    estado: 'no_conectado',
    calendarios: CALENDARIOS_BASE,
    calendarioDestino: 'primary',
    sincronizarAudiencias: true,
    sincronizarCitas: true,
    sincronizarVencimientos: true,
    anticipacionMinutos: 1440,
    direccion: 'sistema_a_google',
  }
}

/** Vinculaciones de ejemplo: tres cuentas conectadas con preferencias distintas y una con error. */
export const CONEXIONES_GOOGLE_INICIALES: ConexionGoogle[] = [
  {
    ...conexionVacia('ab-01'),
    estado: 'conectado',
    correoGoogle: 'mariana.cervantes@gmail.com',
    ultimaSync: haceHoras(2),
    calendarios: CALENDARIOS_BASE,
    calendarioDestino: 'litigio',
    sincronizarAudiencias: true,
    sincronizarCitas: true,
    sincronizarVencimientos: true,
    anticipacionMinutos: 1440,
  },
  {
    ...conexionVacia('ab-04'),
    estado: 'conectado',
    correoGoogle: 'jorge.sandoval@gmail.com',
    ultimaSync: haceHoras(9),
    calendarioDestino: 'primary',
    sincronizarAudiencias: true,
    sincronizarCitas: false,
    sincronizarVencimientos: true,
    anticipacionMinutos: 120,
  },
  {
    ...conexionVacia('ab-05'),
    estado: 'conectado',
    correoGoogle: 'f.oceguera.legal@gmail.com',
    ultimaSync: haceHoras(26),
    calendarioDestino: 'terminos',
    sincronizarAudiencias: true,
    sincronizarCitas: true,
    sincronizarVencimientos: false,
    anticipacionMinutos: 2880,
  },
  {
    ...conexionVacia('ab-03'),
    estado: 'error',
    correoGoogle: 'ana.zuniga.abogada@gmail.com',
    ultimaSync: haceHoras(78),
    mensajeError: 'Google revocó el permiso de acceso. Vuelve a autorizar la cuenta.',
  },
  { ...conexionVacia('ab-06'), invitacionEnviada: haceHoras(50) },
]
